<div class="mb-3">
  <input type="text" class="form-control" [(ngModel)]="operatorName" />
</div>
<fgbcl-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgbcl-registration-navigation>
